import angular from 'angular';
import {
  alerts,
  searchInput,
} from 'app/components/global';
import {
  loaderService,
  ssDialogService,
  pmDataService,
} from 'app/services';
import controller from './change-log-dialog.controller';
import template from './change-log-dialog.html';

class dialogService {
  getOptions($event, { policyDocumentId, changeLogItems, isNavantaUser}) {
    return {
      controller,
      controllerAs: 'changeLogDialogVM',
      locals: {
        policyDocumentId,
        changeLogItems,
        isNavantaUser,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.changeLogDialog', [
  alerts,
  loaderService,
  ssDialogService,
  pmDataService,
  searchInput,
])
  .service('pmChangeLogDialog', dialogService)
  .name;
